import ManageDashboardUsers from './ManageDashboardUsers';

export default ManageDashboardUsers;
